// extracted by mini-css-extract-plugin
export default {"GoBack":"ForgotPwdForm_GoBack__Gdo2P","backLogin":"ForgotPwdForm_backLogin__4MD1c"};